import React from 'react';
import { useTranslation } from 'react-i18next';
import './VisualFarecard.css';
import { Farecard } from '../../services/types/apitypes';
import { currencyFormat } from '../../utils/currency';
import { IonIcon } from '@ionic/react';
import {obfuscateCardNumber} from "../../utils/strings";

type VisualFarecardProps = {
  item: Farecard;
  newCard?: boolean;
};

export default function VisualFarecard({ item, newCard }: VisualFarecardProps) {
  const [t] = useTranslation('global');

  let cssClass = 'virtual';
  if (item && !item.isVirtualCard) {
    if (item.cardId) {
      cssClass = 'physical physicalbg';
    } else {
      cssClass = 'physical';
    }
  }

  return (
    <>
      <div
        className={
          'transit-card ' + cssClass + (item && item.locked ? ' locked ' : '')
        }
      >
        <div className="transit-card-bg"></div>

        {newCard && (
          <div className="transit-card-content-new">
            <span>{t('farecards.name')}</span>
            <span className='nickname no-translate'>{item.nickname || t('farecards.nonickname')}</span>
          </div>
        )}

        <div className="transit-card-content">
          {item.cardId && (
            <>
              {item.locked ? (
                <>
                  <div className="ion-text-center">
                    <IonIcon
                      className="farcards-locked-circle"
                      src="assets/icon/card-locked-circle.svg"
                    ></IonIcon>
                    <div className="pt-2 transit-card-locked-text">
                      {t('farecards.islocked')}
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className="transit-card-top">
                    <span className="label">
                      {item.isVirtualCard ? (
                        <span>{t('farecards.currentvaluevirtual')}</span>
                      ) : (
                        <span>{t('farecards.currentvaluephysical')}</span>
                      )}
                    </span>
                    <span className="value">
                      <span>{currencyFormat(item.balance || 0)}</span>
                    </span>
                  </div>
                  <div className="transit-card-mid">
                    <span className="label">
                      <span>{t('farecards.currentnumber')}</span>
                    </span>
                    <span className="value">
                      <span>{obfuscateCardNumber(item.cardId)}</span>
                    </span>
                  </div>
                  <div className="transit-card-bottom">
                    <span className="autoload">
                      <span className="autoload-label">{t('farecards.autoload')}:</span>
                      <span className="autoload-value">{item.autoloadState}</span>
                    </span>
                  </div>
                </>
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
}
